import React from 'react'
import { BaseEdge, EdgeProps } from 'reactflow'
import useEdge from './useEdge'

const Edge = (props: EdgeProps) => {
  const { path, markerEnd, style } = useEdge(props)

  return (
    <BaseEdge
      path={path}
      markerEnd={markerEnd}
      style={{ stroke: 'red', strokeWidth: 2, ...style }}
    />
  )
}

export default Edge
